



































































































































































































































































































import {Vue, Component} from 'vue-property-decorator';
import {Action, Getter, Mutation} from 'vuex-class';
import Badge from '@/components/Badge.vue';
import AccountService from '@/services/account.service';
import {Account, CommercialAccount, Organisation} from '@/types';
import Table from '@/components/Table.vue';
import {RouterHelper} from '@/router';
import GenericButton from '@/components/GenericButton.vue';
import Dialog from '@/components/Dialog.vue';
import FileUpload from '@/components/FileUpload.vue';
import CancelButton from '@/components/CancelButton.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import OrganisationService from '@/services/organisation.service';
import { Cropper } from 'vue-advanced-cropper';
import {ApiV2Service} from '@/services/api.base.service';
import { getOrgImage } from '@/classes/images';

@Component({
  components: {Cropper, ConfirmButton, CancelButton, FileUpload, Dialog, GenericButton, Table, Badge},
})
export default class AccountSummary extends Vue {

  private get getLogoSrc(): string {
    let src = '';
    if (this.newOrganisation.logo) {
      src = URL.createObjectURL(this.newOrganisation.logo);
    } else if (this.organisationToUpdate.logo) {
      src = URL.createObjectURL(this.organisationToUpdate.logo);
    }
    return src;
  }

  private get availableSubscriptions() {
    if (!this.accountStats[this.activeAccountId] || !this.accountStats[this.activeAccountId][0]) {
      return 0;
    }
    return Number(this.accountStats[this.activeAccountId][0].available_subscriptions) +
        Number(this.accountStats[this.activeAccountId][0].unallocated_subscriptions) +
        Number(this.accountStats[this.activeAccountId][0].detached_subscriptions);
  }
  @Getter private hasPermission: any;
  @Getter private activeAccountId: any;
  @Mutation private addOrganisation: any;
  @Mutation private updateOrganisation: any;
  @Action private addOrganisationsAsync: any;
  @Action private addAccountsAsync: any;
  private addOrganisationDialog: boolean = false;
  private editOrganisationDialog: boolean = false;
  private currentOrganisation: any = null;
  private organisationToUpdate: {name: string; id: number;  billing_account_id?: number | null; logo?: Blob | null; device_monitoring: boolean } = { id: 0, name: '', billing_account_id: null, logo: null, device_monitoring: false };
  private loading: boolean = false;
  private orgHeaders = [
    { text: '', value: 'name', cellClass: 'name-cell-width', sortable: false },
    { text: 'Projects', value: 'projects_total', cellClass: 'number-cell-width', sortable: false, align: 'center' },
    { text: 'Active subscriptions', value: 'active_subscriptions', cellClass: 'number-cell-width', sortable: false, align: 'center'  },
    { text: 'Available subscriptions', value: 'available_subscriptions', cellClass: 'number-cell-width', sortable: false, align: 'center'  },
    { text: 'Total devices', value: 'devices_total', cellClass: 'number-cell-width', sortable: false, align: 'center'  },
    // { text: 'Users', value: 'users_total', cellClass: 'number-cell-width', sortable: false, align: 'center'  },
  ];
  private accountStats: {[key: string]: any} = {};
  private account: any = { name: '', id: 0 };
  private newOrganisation: { name: string; billing_account_id: number | null; logo?: Blob | null; device_monitoring: boolean } = { name: '', billing_account_id: null, logo: null, device_monitoring: false };
  private saveImage: boolean = false;
  private croppedLogo: Blob | null = null;
  private showCropper: boolean = false;
  private orgTableHasScrollbar: boolean = false;

  public checkOrgTableScrollbar() {
    if (this.$refs.orgTable) {
      const tableComponentRootElement = (this.$refs.orgTable as any).$el;
      if (!tableComponentRootElement) {
        this.orgTableHasScrollbar = false;
        return;
      }
      const scrollableElement = tableComponentRootElement.querySelector('.v-data-table__wrapper');
      if (!scrollableElement) {
        this.orgTableHasScrollbar = false;
        return;
      }

      const verticalCheck = scrollableElement.scrollHeight > scrollableElement.clientHeight;
      if (this.orgTableHasScrollbar !== verticalCheck) {
        this.orgTableHasScrollbar = verticalCheck;
      }
    }
  }

  private async mounted() {
    this.loading = true;
    await this.getAccountSummary();

    this.$nextTick(() => {
      this.checkOrgTableScrollbar();
    });
  }

  private async loadOrganisation() {
    const orgLogo = this.getOrgImage();
    if (this.currentOrganisation) {
      this.organisationToUpdate.name = this.currentOrganisation.name;
      this.organisationToUpdate.billing_account_id = this.currentOrganisation.billing_account_id;
      this.organisationToUpdate.device_monitoring = this.currentOrganisation.device_monitoring;
      try {
        if (orgLogo.length) {
          this.organisationToUpdate.logo = await ApiV2Service.getBlobExt(orgLogo, {crossDomain: true});
        }
      } catch (e) {
        // tslint:disable-next-line
        console.warn(e);
      } finally {
        this.editOrganisationDialog = true;
      }
    }
  }

  private getOrgImage(): string {
    if (this.currentOrganisation && this.currentOrganisation.slug) {
      return getOrgImage(this.currentOrganisation);
    } else {
      return '';
    }
  }

  private async getAccountSummary() {
    try {
      this.account = await AccountService.getAccountSummary(this.activeAccountId);
      this.setAccountStats(this.account);
    } finally {
      this.loading = false;
    }
  }

  private removeLogo(): void {
    this.saveImage = true;
    this.newOrganisation.logo = null;
    this.organisationToUpdate.logo = null;
  }

  private async handleFileUpload(file: any): Promise<void> {
    this.saveImage = true;
    this.newOrganisation.logo = file.files[0];
    this.organisationToUpdate.logo = file.files[0];
  }

  private async onCropperChange(event: any) {
    const canvas: HTMLCanvasElement = event.canvas;
    await (new Promise((res, reject) =>
        canvas.toBlob((blob: Blob | null) => {
          this.croppedLogo = blob;
        }, 'image/png'),
    ));
  }

  private getImageSize(event: any) {
    this.showCropper = event.target.height !== event.target.width;
    if (!this.showCropper) {
      event.target.style.visibility = 'visible';
    }
  }

  private async saveNewOrganisation() {
    this.loading = true;
    try {
      this.newOrganisation.billing_account_id = this.activeAccountId;
      const organisation = await AccountService.createOrganisation(this.activeAccountId, this.newOrganisation);
      this.addOrganisation(organisation);
      if (organisation) {
        if (this.saveImage) {
          if (this.croppedLogo || this.newOrganisation.logo) {
            await OrganisationService.uploadOrganisationLogo(organisation.id, this.croppedLogo || (await this.newOrganisation.logo!.toPNG()));
            if (this.croppedLogo) {
              this.showCropper = false;
              this.newOrganisation.logo = this.croppedLogo;
              this.$forceUpdate();
            }
          } else {
            await OrganisationService.removeOrganisationLogo(organisation.id);
          }
        }
      }
    } finally {
      this.closeDialog();
      this.loading = false;
      await this.addOrganisationsAsync();
      await this.addAccountsAsync();
      await this.getAccountSummary();
    }
  }
  private async editOrganisation() {
    this.loading = true;
    try {
      const organisation = await AccountService.updateOrganisation(this.activeAccountId, this.currentOrganisation!.id,  this.organisationToUpdate);
      this.updateOrganisation(organisation);
      if (organisation) {
        if (this.saveImage) {
          if (this.croppedLogo || this.organisationToUpdate.logo) {
            await OrganisationService.uploadOrganisationLogo(organisation.id, this.croppedLogo || (await this.organisationToUpdate.logo!.toPNG()));
            if (this.croppedLogo) {
              this.showCropper = false;
              this.organisationToUpdate.logo = this.croppedLogo;
              this.$forceUpdate();
            }
          } else {
            await OrganisationService.removeOrganisationLogo(organisation.id);
          }
        }
      }
    } finally {
      this.closeDialog();
      this.loading = false;
      await this.getAccountSummary();
    }
  }

  private closeDialog() {
    this.editOrganisationDialog = false;
    this.addOrganisationDialog = false;
    this.newOrganisation = {name: '', billing_account_id: null, logo: null, device_monitoring: false};
    this.organisationToUpdate = {id: 0, name: '', billing_account_id: null, logo: null, device_monitoring: false};
  }

  private getTotalDevices(item: any) {
    const sumDeviceCounts = (data: any) => {
      return Object.keys(data)
          .filter((key) => key.startsWith('devices_'))
          .reduce((sum, key) => sum + (data[key] || 0), 0);
    };
    return sumDeviceCounts(item);
  }

  private setAccountStats(account: CommercialAccount & { unallocated_subscriptions?: number; }) {
    Vue.set(this.accountStats, account.id, {});
    let projectsTotal = 0;
    let usersTotal = 0;
    let devicesTotal = 0;
    let devicesStock = 0;
    let devicesDeployed = 0;
    let devicesTest = 0;
    let activeSubscriptions = 0;
    let availableSubscriptions = 0;
    let notRenewingSubscriptions = 0;
    let detachedSubscriptions = 0;

    if (!account || !account.organisations) {
      return;
    }

    for (const organisation of account.organisations) {
      projectsTotal += organisation.projects_total;
      usersTotal += organisation.users_total;
      devicesTotal += this.getTotalDevices(organisation);
      devicesStock += organisation.devices_stock;
      devicesDeployed += organisation.devices_deployed;
      devicesTest += organisation.devices_test;
      activeSubscriptions += organisation.active_subscriptions;
      availableSubscriptions += organisation.available_subscriptions;
      notRenewingSubscriptions += organisation.not_renewing_subscriptions;
      detachedSubscriptions += organisation.detached_subscriptions;
    }

    this.accountStats[account.id] = {};
    this.accountStats[account.id] = [{
      name: account.name,
      projects_total: projectsTotal,
      users_total: usersTotal,
      devices_total: devicesTotal,
      devices_stock: devicesStock,
      devices_deployed: devicesDeployed,
      devices_test: devicesTest,
      active_subscriptions: activeSubscriptions,
      available_subscriptions: availableSubscriptions,
      not_renewing_subscriptions: notRenewingSubscriptions,
      detached_subscriptions: detachedSubscriptions,
      unallocated_subscriptions: account.unallocated_subscriptions,
    }];
  }

  private async showEditOrganisation(organisation: Organisation) {
    this.currentOrganisation = {...organisation};
    await this.loadOrganisation();
  }

  private async goToOrg(organisation: Organisation) {
    await RouterHelper.switchOrganisation(Number(organisation.id));
    this.$router.push({ name: 'projectcomposer', params: { organisationId: organisation.id.toString() } });
  }

  private get alphabetisedOrgs() {
    return this.account.organisations.sort((a: Organisation, b: Organisation) => a.name.localeCompare(b.name));
  }
}
